import { Entity, EntityId } from "game-common/models"
import { Graphics } from "pixi.js"

import { paperdollFor } from "../sprites/ember_portrait"
import { DyanmicTextContainer, DyanmicTextContainerProps } from "./dynamic_text_container"

export interface EntityDisplayerProps {
    entityId: EntityId
    scale?: number
}

export class EntityDisplayer extends DyanmicTextContainer {
    entityProps: EntityDisplayerProps
    entity: Entity

    constructor(entityProps: EntityDisplayerProps, entity: Entity, props?: DyanmicTextContainerProps) {
        super(props)
        this.entityProps = entityProps
        this.entity = entity
    }

    createContent = (): DyanmicTextContainer => {
        const content = new DyanmicTextContainer()

        // The body the entity has in the world: an Ember one where it has one, else its LPC paperdoll.
        const portrait = paperdollFor(this.entity, this.entity.entityId, false, "figure")
        portrait.scale.set(this.entityProps.scale || 3)
        const holder = new Graphics()
        holder.addChild(portrait)

        content.append2(holder, {
            topMargin: 32,
            leftMargin: 32,
        })

        return content
    }
}
